// Compartir un texto: el menú del celular (WhatsApp, etc.) si existe, y si no,
// copiarlo al portapapeles.
//
// Existe para que el link largo del sitio no tenga que tipearlo nadie nunca:
// se manda una vez, y después se usa el ícono de la app instalada.

export type ResultadoCompartir = 'compartido' | 'copiado' | 'cancelado' | 'fallo';

export async function compartir(titulo: string, texto: string): Promise<ResultadoCompartir> {
  if (typeof navigator.share === 'function') {
    try {
      await navigator.share({ title: titulo, text: texto });
      return 'compartido';
    } catch (e) {
      // Cerrar el menú sin elegir nada no es un error.
      if (e instanceof DOMException && e.name === 'AbortError') return 'cancelado';
      // Cualquier otra cosa: se intenta copiar.
    }
  }
  try {
    await navigator.clipboard.writeText(texto);
    return 'copiado';
  } catch {
    return 'fallo';
  }
}

/** El link del sitio, tal como lo está usando quien comparte. */
export function linkDelSitio(): string {
  return `${window.location.origin}/`;
}
